import { call, put, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { replace } from 'connected-react-router';
import * as loginApi from '../../services/loginApi';
import { isMC,isMini } from 'src/utils/env';
import { isProd } from 'src/utils';
import md5 from 'js-md5'
import { random } from 'lodash';
import { requestCreateTime } from '../../services/loginApi';
import { STORAGE, setStorage } from '../../tools/storage';

const initialState = {
  qrcode: '',
  code: '',
  codeAir: '',
  loading: false,
  percent: 0,
  total: 14,
  isFetchCode: false, // 是否在请求qr-code
  airAppPid:'5', //air的pid
  airSecret:'oEYy7vNZAgIAWbP2Sm1Fpj9pJFFJUDDt', // air的授权密钥
  mcAppPid:'5-MC', // mc的pid
  mcSecret:'TIYZ5GuvK2CEzfTHvK4Uw2TGxrkR5UT1', // mc的授权密钥
  miniAppPid:'5-Mini', // 小哆客的pid
  miniSecret:'XOKbGoQewumicn7hfaiV6yPT1hAelQch', // 小哆客的密钥
  nowTime:'' , // 时间戳
  random:'' , // 随机标识符
  isTimeOut:false, // 是否超时
};

export const state = initialState;
export const effects = {
  *fetchQrCodeAndCheck() {
    const { loginState } = yield select();
    if (!loginState.isFetchCode) {
      yield put({ type: 'login/setState', payload: { isFetchCode: true}});
      yield put({ type: 'login/fetchAirQrCode' });
      yield put({ type: 'login/fetchCheckAirLogin' });
    }
  },
  //获取air 二维码
  *fetchAirQrCode() {
    while (true) {
      const { appState } = yield select((state) => state);
      if (appState.token) break;
      // const res = yield call(loginApi.requestUserRandom);

      const len = 12;
      const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz0123456789';
      let random = '';
      for(let i = 0;i<len;i++){
        random += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      const res = yield call(loginApi.requestCreateTime);
      const nowTime = res?.['unix_timestamp'] ?? parseInt(new Date().getTime() / 1000);
      let pid = state.airAppPid;
      let secret = state.airSecret
      if(isMC()){
        pid = state.mcAppPid;
        secret = state.mcSecret;
      }else if(isMini()){
        pid = state.miniAppPid;
        secret = state.miniSecret;
      }

      const psw = `${pid}&${random}&${nowTime}&${secret}`
      const code = md5(psw); // md5加密结果

      const host = isMC() ? 'mc2-h5' : 'air-web';
      const testEnv = isMC() ? '-beta' : '-test';
      const route = isMC() ? 'dokkr' : 'duoke';
      const pageCode = `${pid}&${random}&${nowTime}&${code}`
      const qrcodeUrl = `https://${host}${isProd() ? '' : testEnv}.${route}.net/auth.html#/?type=5&secretCode=${encodeURIComponent(pageCode)}`;
      yield put({ type: 'login/setState', payload: { qrcode: qrcodeUrl, codeAir: code, nowTime:nowTime,random:random } });
      yield delay(1000 * 60 * 12);
    }
  },

  //检查air 返回token
  *fetchCheckAirLogin() {
    while (true) {
      const { codeAir,nowTime,random,isTimeOut } = yield select(({ loginState }) => loginState);
      if (codeAir && !isTimeOut) {
        let pid = state.airAppPid;
      if(isMC()){
        pid = state.mcAppPid;
      }else if(isMini()){
        pid = state.miniAppPid;
      }
        const code = `${pid}&${random}&${nowTime}&${codeAir}`;
        const res = yield call(loginApi.requestAirToken, { code: code });
        // 6244到期,6245二维码过期失效，两个提示内容不同所以分两个错误码
        if (res && res.err === 6244) {
          yield put({ type: 'login/fetchAirQrCode' });
        }else if(res &&res.err === 6245){
          yield put({type:'login/setState',payload:{isTimeOut:true}})
        }
        if (res && res.token) {
          // 登录成功
          yield put({ type: 'login/setState', payload: { loading: true, percent: 0.49} });
          yield put({
            type: 'app/setState',
            payload: { token: res.token, maskToken: res.mask_token },
          });
          setStorage(STORAGE.ADMIN_TOKEN,res.token)
          setStorage(STORAGE.ADMIN_MASK_TOKEN,res.mask_token)
          yield put.resolve({ type: 'app/syncAppData' });
          yield put({ type: 'login/setState', payload: { percent: 1 } });
          yield call(delay, 500)
          yield put({ type: 'login/redirect'})
          yield put({ type: 'login/setState', payload: { loading: false } });
          break;
        }
      }
      yield call(delay, 1000);
    }
  },

  // 根据角色不同重定向首页
  *redirect() {
    const {
      userInfo: { role },
    } = yield select(({ appState }) => appState);
    let baseRoute = ''
    if (isMC()) {
      baseRoute = role === 'ProductManager' ? '/mc/good/good-manage' : '/mc/'
    } else {
      baseRoute = role === 'ProductManager' ? '/v2/good/good-manage' : '/v2/'
    }
    yield put(replace(baseRoute))
  },

  // token 授权登录
  *tokenAuthLogin({ payload }) {
    // 获取个人信息
    const { token, mask_token } = payload;

    yield put({ type: 'app/setState', payload: { token, maskToken: mask_token } });
    const ret = yield put.resolve({ type: 'login/initUser' });
    // fixme: Air授权
    if (ret) {
      // 授权成功
      yield put.resolve({ type: 'app/syncAppData' });
      yield put(replace('/v3'));
    } else yield put(replace('/login'));
  },

  // 登出
  *logout(action) {
    setStorage(STORAGE.ADMIN_TOKEN,'')
    setStorage(STORAGE.ADMIN_MASK_TOKEN,'')
    yield put({ type: 'app/setState', payload: { token: '', maskToken: '' } });
    yield put({ type: 'login/setState', payload: { code: '', codeAir: '', percent: 0, isFetchCode: false } });
    yield put(replace('/login'));
  },
};

export const reducers = {};
